export default class faqModel {
    constructor({ id, question, answer, language, target, is_active, created_by_name }) {
      this.id = id;
      this.question = question;
      this.answer = answer;
      this.language = language;
      this.target = target;
      this.status = is_active;
      this.created_by_name = created_by_name;
    }
}